

export const frontMatter = {
	title: 'Registering Panels',
	sidebar_position: 0
};
export const contentTitle = undefined;
export const metadata = {
  "id": "core/panels/register",
  "title": "Registering Panels",
  "description": "This section describes how to register a panel.",
  "source": "@site/docs/core/panels/register.mdx",
  "sourceDirName": "core/panels",
  "slug": "/core/panels/register",
  "permalink": "/docs/core/panels/register",
  "draft": false,
  "unlisted": false,
  "tags": [],
  "version": "current",
  "sidebarPosition": 0,
  "frontMatter": {
    "title": "Registering Panels",
    "sidebar_position": 0
  },
  "sidebar": "tutorialSidebar",
  "previous": {
    "title": "Overview",
    "permalink": "/docs/core/overview"
  },
  "next": {
    "title": "Adding Panels",
    "permalink": "/docs/core/panels/add"
  }
};
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {DocRef} from '@site/src/components/ui/reference/docRef';
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    p: "p",
    pre: "pre",
    ..._provideComponents(),
    ...props.components
  }, {FrameworkSpecific} = _components;
  if (!FrameworkSpecific) _missingMdxReference("FrameworkSpecific", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "This section describes how to register a panel."
    }), "\n", _jsxs(_components.p, {
      children: ["You can register panels through the dock  ", _jsx(_components.a, {
        href: "/docs/api/dockview/options",
        children: "option"
      }), " ", _jsx(_components.code, {
        children: "components"
      }), "."]
    }), "\n", _jsx(FrameworkSpecific, {
      framework: "React",
      children: _jsx(DocRef, {
        declaration: "IDockviewReactProps",
        methods: ['components']
      })
    }), "\n", _jsx(FrameworkSpecific, {
      framework: "Vue",
      children: _jsx(DocRef, {
        declaration: "IDockviewVueProps",
        methods: ['components']
      })
    }), "\n", _jsx(FrameworkSpecific, {
      framework: "JavaScript",
      children: _jsx(DocRef, {
        declaration: "DockviewComponentOptions",
        methods: ['createComponent']
      })
    }), "\n", _jsx(FrameworkSpecific, {
      framework: "React",
      children: _jsx(_components.pre, {
        children: _jsx(_components.code, {
          className: "language-tsx",
          children: "const components = {\n  component_1: (props: IDockviewPanelProps) => {\n    const api: DockviewPanelApi  = props.api;\n    const groupApi: DockviewGroupPanelApi  = props.group.api;\n    const containerApi: DockviewApi  = props.containerApi;\n\n    return <div>{/** logic */}</div>\n  },\n  component_2: (props: IDockviewPanelProps) => {\n    return <div>{/** logic */}</div>\n  }\n}\n\nreturn <DockviewReact components={components}/>\n"
        })
      })
    }), "\n", _jsx(FrameworkSpecific, {
      framework: "JavaScript",
      children: _jsx(_components.pre, {
        children: _jsx(_components.code, {
          className: "language-tsx",
          children: "class Panel implements IContentRenderer {\n    private readonly _element: HTMLElement;\n\n    get element(): HTMLElement {\n        return this._element;\n    }\n\n    constructor() {\n        this._element = document.createElement('div');\n    }\n\n    init(parameters: GroupPanelPartInitParameters): void {\n        //\n    }\n}\n\n\nconst api = createDockview(parentElement, {\n    createComponent: (options) => {\n        switch (options.name) {\n            case 'component_1':\n                return new Panel();\n        }\n    },\n});\n"
        })
      })
    }), "\n", _jsx(FrameworkSpecific, {
      framework: "Vue",
      children: _jsx(_components.pre, {
        children: _jsx(_components.code, {
          className: "language-tsx",
          children: "const App = {\n    name: 'App',\n    components: {\n        'component_1': VueComponent1,\n        'component_2': VueComponent2,\n    },\n    methods: {\n        onReady(event: DockviewReadyEvent) {\n            event.api.addPanel({\n                id: 'panel_1',\n                component: 'component_1'\n            });\n\n               event.api.addPanel({\n                id: 'panel_2',\n                component: 'component_2'\n            });\n        },\n    },\n    template: `\n      <dockview-vue\n        @ready=\"onReady\"\n      >\n      </dockview-vue>`,\n};\n"
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Each panel has an ", _jsx(_components.a, {
        href: "/docs/api/dockview/panelApi",
        children: "api"
      }), " which is used to control specific\nfeatures on that individual panel.\nThe panel also has access the ", _jsx(_components.a, {
        href: "/docs/api/dockview/groupApi",
        children: "group api"
      }), " and the container\n", _jsx(_components.a, {
        href: "/docs/api/dockview/overview",
        children: "api"
      }), "."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

